import Facebook from "@bToC/Icons/Facebook";
import Linkedin from "@bToC/Icons/Linkedin";
// import Mail from "@bToC/Icons/Mail"; Change gerrie Icon to Mobius
import Twitter from "@bToC/Icons/Twitter";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductShareLink, { ProductShareLinkStyles } from "@insite/content-library/Components/ProductShareLink";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";

import Mail from "@insite/mobius/Icons/Mail";
import Printer from "@insite/mobius/Icons/Printer";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    direction = "direction",
    alignment = "alignment",
    iconSize = "iconSize",
    iconColor = "iconColor",
    title = "title",
    showLabel = "showLabel",
    showPrint = "showPrint",
    showFacebook = "showFacebook",
    facebookAppId="facebookAppId",
    showTwitter = "showTwitter",
    showLinkedin = "showLinkedin",
    linkedinAppUrl= "linkedinAppUrl",
    showShareProduct = "showShareProduct",
}

const enum icons {
    facebook = "Facebook",
    twitter = "Twitter",
    linkedin ="linkedin",
    printer = "Printer",
    mail="Mail"
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.showLabel]: boolean;
        [fields.showPrint]: boolean;
        [fields.showFacebook]: boolean;
        [fields.facebookAppId]: string;
        [fields.showTwitter]: boolean;
        [fields.showLinkedin]: boolean;
        [fields.linkedinAppUrl]: string;
        [fields.showShareProduct]: boolean;
        [fields.direction]: "vertical" | "horizontal";
        [fields.alignment]: "left" | "right";
        [fields.iconSize]: number;
        [fields.iconColor]: string;
    };
}

type Props = OwnProps & HasProduct & ReturnType<typeof mapStateToProps>;


const mapStateToProps = (state: ApplicationState) => ({
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
    website: state.context.website,
    selectedProductPath: state.context.selectedProductPath
});

export interface ProductDetailsShareSocialLinkStyles {
    gridItem: InjectableCss;
    socialLinksShareText: InjectableCss;
    container: InjectableCss;
    wrapper?: InjectableCss;
    link?: ProductShareLinkStyles;
    productSharelink?: ProductShareLinkStyles;
}

export const shareLinkStyles: ProductDetailsShareSocialLinkStyles = {
    container:{
        css: css`
        > div[class^="GridOffset"] {flex-wrap: nowrap;}
        
        `
    },
    wrapper: {
        css: css`
            margin-top: 30px;
            text-align: center;
        `,
    },
    gridItem:{
        css: css`
            padding-right: 25px;
            margin-right: 0px;
            max-width: 50px;
            padding-left: 5px;
            padding-right: 5px;
        `
    },
    socialLinksShareText:{
        css: css`
            padding-right: 25px;
            padding-top: 30px;
            word-break:normal;
        `
    },
};
const GetIcon = (icon: string) => {
    let retIcon;
    switch (icon) {
        case icons.twitter:
            retIcon = Twitter;
            break;
        case icons.facebook:
            retIcon = Facebook;
            break;
        case icons.printer:
            retIcon = Printer;
            break;
        case icons.mail:
            retIcon = Mail;
            break;
        case icons.linkedin:
            retIcon = Linkedin;
            break;
        default:
            return "";
    }

    return retIcon as React.FunctionComponent<{}>;
};

const styles = shareLinkStyles;

const ProductDetailsShareSocialLink: React.FC<Props> = ({ fields, product , website,selectedProductPath}) => {
    if (!product) {
        return null;
    }
    styles.productSharelink={ 
        link:{
        icon:{
            iconProps: {
                size: fields.iconSize,
                color: fields.iconColor,
                css: css`
                        margin: 5px;
                        `,
                src: GetIcon(icons.mail) || undefined,
                title: "Mail"
            },
            position: fields.alignment
        }
    }
    }
    const siteUri=new URL(website.uri);
    const productUrl = new URL(`https://${siteUri.hostname}/product/${product.urlSegment}`);
    const facebookUrl=`https://www.facebook.com/dialog/share?app_id=${fields.facebookAppId}&display=popup&href=${productUrl}&redirect_uri=${productUrl}&description=${product.productTitle}`;
    const twitterUrl=`https://twitter.com/intent/tweet?url=${productUrl}&&text=${product.productTitle}`;
    const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${productUrl}`;
    return (
        <StyledWrapper {...styles.container}>
            <GridContainer
                data-test-selector={`productDetailsShareSocialLink${product.id}`} {...styles.container} >
                {fields.title && (<GridItem  width={4} {...styles.socialLinksShareText}>
                <Typography>{fields.title}:</Typography>
                </GridItem>)}
                {fields.showFacebook && (
                    <GridItem width={2} {...styles.gridItem}>
                    <Link
                        {...styles.link}
                        href={facebookUrl} 
                        icon={{
                            iconProps: {
                                size: fields.iconSize,
                                color: fields.iconColor,
                                css: css`
                                        margin: 5px;
                                        margin-left:18px;
                                        `,
                                src: GetIcon(icons.facebook) || undefined,
                                title: "Facebook",
                            },
                            position: fields.alignment,
                        }}
                        target="_blank"
                    >
                        {fields.showLabel && "Facebook"}
                    </Link>
                    </GridItem>
                )}
                {fields.showTwitter && (
                    <GridItem width={2} {...styles.gridItem}>
                    <Link
                        {...styles.link}
                        href={twitterUrl} 
                        icon={{
                            iconProps: {
                                size: fields.iconSize,
                                color: fields.iconColor,
                                css: css`
                                        margin: 5px;
                                        `,
                                src: GetIcon(icons.twitter) || undefined,
                                title: "Twitter",
                            },
                            position: fields.alignment,
                        }}
                    >
                        {fields.showLabel && "Twitter"}
                    </Link>
                    </GridItem>
                )}
                    {fields.showLinkedin && (
                    <GridItem width={2} {...styles.gridItem}>
                    <Link
                        {...styles.link}
                        href={linkedinUrl} 
                        icon={{
                            iconProps: {
                                size: fields.iconSize,
                                color: fields.iconColor,
                                css: css`
                                        margin: 5px;
                                        `,
                                src: GetIcon(icons.linkedin) || undefined,
                                title: "Linkedin",
                            },
                            position: fields.alignment,
                        }}
                        target="_blank"
                    >
                        {fields.showLabel && "Linkedin"}
                    </Link>
                    </GridItem>
                )}
                {fields.showShareProduct && (<GridItem width={2} {...styles.gridItem}>
                    <ProductShareLink text=" " extendedStyles={styles.productSharelink} />
                </GridItem>)}
                
                {fields.showPrint && (
                    <GridItem width={2} {...styles.gridItem}>
                    <Link
                        {...styles.link}
                        onClick={() => window.print()}
                        icon={{
                            iconProps: {
                                size: fields.iconSize,
                                color: fields.iconColor,
                                css: css`
                                        margin: 5px;
                                        `,
                                src: GetIcon(icons.printer) || undefined,
                                title: "Print",
                            },
                            position: fields.alignment,
                        }}
                    >
                        {fields.showLabel && "Print"}
                    </Link>
                    </GridItem>
                )}
            </GridContainer>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(ProductDetailsShareSocialLink)),
    definition: {
        displayName: "Share Product to Social Links",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "Share",
                fieldType: "General",
            },
            {
                name: fields.showLabel,
                displayName: "Show Link Labels",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.showFacebook,
                displayName: "Show Facebook Link",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.facebookAppId,
                displayName: "Facebook App Id",
                editorTemplate: "TextField",
                fieldType: "General",
                defaultValue: "",
                isVisible: item => item.fields.showFacebook
            },
            {
                name: fields.showTwitter,
                displayName: "Show Twitter Link",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.showLinkedin,
                displayName: "Show Linkedin Link",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.linkedinAppUrl,
                displayName: "Linkedin App URL",
                editorTemplate: "TextField",
                fieldType: "General",
                defaultValue: "",
                isVisible: item => item.fields.showLinkedin
            },
            {
                name: fields.showShareProduct,
                displayName: "Show Share Product Link",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.showPrint,
                displayName: "Show Print Link",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.iconSize,
                displayName: "Icon Size",
                editorTemplate: "IntegerField",
                defaultValue: 30,
                min: 1,
                fieldType: "General",
            }, {
                name: fields.iconColor,
                displayName: "Icon Color",
                editorTemplate: "ColorPickerField",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.direction,
                displayName: "Display",
                editorTemplate: "RadioButtonsField",
                defaultValue: "horizontal",
                fieldType: "General",
                options: [
                    {
                        displayName: "Column",
                        value: "vertical",
                    },
                    {
                        displayName: "Row",
                        value: "horizontal",
                    },
                ],
            },
            {
                name: fields.alignment,
                displayName: "Text Position",
                editorTemplate: "RadioButtonsField",
                defaultValue: "left",
                fieldType: "General",
                options: [
                    {
                        displayName: "Left of icon",
                        value: "left",
                    },
                    {
                        displayName: "Right of icon",
                        value: "right",
                    },
                ],
            }
        ],
    }
};

export default widgetModule;
